<template>
	<!-- 投注提示 -->
	<div class="betting_frame_box hint">
		<div class="bet_frame_mainbox">
			<div class="bet_top_title">
				提示
				<div class="close_login" @click="hide">
					<span></span>
				</div>
			</div>
			<i class="el-icon-warning"></i>
			<p>请至少选择一组投注号码</p>
			<el-button type="primary" class="bet_frame_sure" @click="hide">确定</el-button>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
	methods: {
		hide() {
			this.$emit("bethide");
		},
	},
};
</script>
<style>
.betting_frame_box {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 88;
}

.hint .bet_frame_mainbox {
	height: 270px;
	width: 400px;
	position: absolute;
	left: 0;
	top: 0;
	margin: auto;
	bottom: 0;
	right: 0;
	background: #ffffff;
	border-radius: 10px;
	text-align: center;
}

.hint .bet_frame_mainbox > .bet_top_title {
	position: relative;
	width: 100%;
	height: 45px;
	text-align: left;
	color: #fff;
	box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.12);
	background-color: #6455fe;
	line-height: 45px;
	padding: 0 20px;
	font-size: 16px;
	cursor: pointer;
	border-radius: 10px 10px 0 0;
	position: relative;
}

.hint .bet_frame_mainbox > .bet_top_title::after {
	content: "";
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	/* background-image: url("../../static/img/white_shadow.png"); */
	width: 54%;
	height: 29px;
	background-size: cover;
}

.hint .bet_frame_mainbox > .bet_top_title > span {
	display: inline-block;
	position: absolute;
	top: 0;
	right: 0;
	width: 30px;
	height: 45px;
	font-size: 18px;
	color: #ffffff;
}

.hint .bet_frame_mainbox > .el-icon-warning {
	color: #6455fe;
	font-size: 52px;
	margin-top: 34px;
}

.hint .bet_frame_mainbox > p {
	text-align: center;
	color: #232924;
	margin-top: 20px;
	/* font-weight: bold; */
	font-weight: 400;
}

.hint .bet_frame_sure {
	margin: 24px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/Betting_minone.vue